/**
 * 浏览域本地存储(替代 App MMKV):首页选中品类记忆 + 搜索历史。
 * 全部 try/catch 包裹:隐私模式/禁用 localStorage 时降级不崩(home.md / search.md 边界)。
 */
const CATEGORY_KEY = 'wab-web-home-category';
const HISTORY_KEY = 'wab-web-search-history';
const MAX_HISTORY = 10;

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function safeSet(key: string, val: string): void {
  try {
    localStorage.setItem(key, val);
  } catch {
    /* 降级:不持久化,不崩 */
  }
}
function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* 降级 */
  }
}

/** 首页选中的一级品类 id(未选过 → null → 默认推荐)。 */
export function getHomeCategory(): string | null {
  return safeGet(CATEGORY_KEY);
}
export function setHomeCategory(id: string | null): void {
  if (id) safeSet(CATEGORY_KEY, id);
  else safeRemove(CATEGORY_KEY);
}

/** 搜索历史(最多 10 条,最近在前)。 */
export function getSearchHistory(): string[] {
  const raw = safeGet(HISTORY_KEY);
  if (!raw) return [];
  try {
    const arr: unknown = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}
/** 写入一条历史:trim 空则不变;去重置顶;超 10 挤掉最旧。 */
export function pushSearchHistory(q: string): string[] {
  const term = q.trim();
  if (!term) return getSearchHistory();
  const next = [term, ...getSearchHistory().filter((h) => h !== term)].slice(0, MAX_HISTORY);
  safeSet(HISTORY_KEY, JSON.stringify(next));
  return next;
}
export function clearSearchHistory(): string[] {
  safeRemove(HISTORY_KEY);
  return [];
}
